export default "__VITE_ASSET__DMrZhwrh__"